import {
    accountSessionsSlice,
    addressKeysReducer,
    addressesReducer,
    apiStatusReducer,
    domainsReducer,
    featureTourReducer,
    groupMembersReducer,
    groupMembershipsReducer,
    groupOwnerInvitesReducer,
    groupsReducer,
    inactiveKeysReducer,
    ktSlice,
    memberReducer,
    membersReducer,
    organizationKeyReducer,
    organizationReducer,
    organizationThemeSlice,
    paymentStatusReducer,
    plansReducer,
    previousSubscriptionReducer,
    protonDomainsReducer,
    referralInfoReducer,
    referralsReducer,
    scheduleCallReducer,
    securityCheckupSlice,
    subscriptionReducer,
    userInvitationsReducer,
    userKeysReducer,
    userPermissionsReducer,
    userReducer,
    userSettingsReducer,
    vpnServersCountReducer,
    welcomeFlagsReducer,
} from '@proton/account';
import { sessionRecoverySlice } from '@proton/account/recovery/sessionRecovery';
import { featuresReducer } from '@proton/features';
import { contactEmailsReducer } from '@proton/mail/store/contactEmails';
import { contactsReducer } from '@proton/mail/store/contacts';
import { contactReducer } from '@proton/mail/store/contacts/contactSlice';
import { importerConfigReducer } from '@proton/mail/store/importerConfig';
import { categoriesReducer } from '@proton/mail/store/labels';
import { mailSettingsReducer } from '@proton/mail/store/mailSettings';
import { selectPersistModel } from '@proton/redux-utilities/creator';

export const sharedReducers = {
    ...apiStatusReducer,
    ...userReducer,
    ...userKeysReducer,
    ...plansReducer,
    ...addressesReducer,
    ...addressKeysReducer,
    inactiveKeys: inactiveKeysReducer,
    ...userSettingsReducer,
    ...mailSettingsReducer,
    ...subscriptionReducer,
    ...previousSubscriptionReducer,
    ...paymentStatusReducer,
    ...organizationReducer,
    ...organizationKeyReducer,
    ...protonDomainsReducer,
    ...domainsReducer,
    organizationTheme: organizationThemeSlice.reducer,
    ...userInvitationsReducer,
    ...contactReducer,
    ...contactsReducer,
    ...contactEmailsReducer,
    ...categoriesReducer,
    ...importerConfigReducer,
    ...vpnServersCountReducer,
    ...welcomeFlagsReducer,
    ...memberReducer,
    ...membersReducer,
    ...scheduleCallReducer,
    ...groupsReducer,
    ...groupMembersReducer,
    ...groupMembershipsReducer,
    ...groupOwnerInvitesReducer,
    ...featureTourReducer,
    ...referralInfoReducer,
    ...referralsReducer,
    ...userPermissionsReducer,
    kt: ktSlice.reducer,
    securityCheckup: securityCheckupSlice.reducer,
    features: featuresReducer.reducer,
    sessions: accountSessionsSlice.reducer,
    sessionRecovery: sessionRecoverySlice.reducer,
};

export const sharedPersistReducer: Partial<{ [key in keyof typeof sharedReducers]: any }> = {
    user: selectPersistModel,
    addresses: selectPersistModel,
    userSettings: selectPersistModel,
    mailSettings: selectPersistModel,
    subscription: selectPersistModel,
    contacts: selectPersistModel,
    contactEmails: selectPersistModel,
    plans: selectPersistModel,
    categories: selectPersistModel,
    organization: selectPersistModel,
    userInvitations: selectPersistModel,
    vpnServersCount: selectPersistModel,
    protonDomains: selectPersistModel,
    domains: selectPersistModel,
    previousSubscription: selectPersistModel,
    referralInfo: selectPersistModel,
    features: (state: any) => state,
};
